export default {"src":"/_next/static/media/verizon.f0abebce.svg","height":146,"width":658};